import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {UntypedFormControl, UntypedFormGroup, Validators} from '@angular/forms';
import {merge} from 'lodash-es';
import {ApiResponse} from "../../../classes/api-response";
import {SnackService} from "../../../services/snack.service";
import {Box} from "../../../model/box";
import {BoxesService} from "../../../services/boxes-service";
import {SimsService} from "../../../services/sims.service";
import {BoxInterfacesService} from "../../../services/box-interfaces.service";
import {Constants} from "../../../utils/constants";
import {BoxInterface} from "../../../model/box-interface";
import {AssignBoxInterfaceDTO} from 'src/app/model/dto/box-interface/assign-box-interface.dto';
import {transformAndValidateSync, TransformValidationOptions} from 'class-transformer-validator';

@Component({
  selector: 'aw-add-box-interface-to-box',
  templateUrl: './add-box-interface-to-box.component.html',
  styleUrls: ['./add-box-interface-to-box.component.scss']
})
export class AddBoxInterfaceToBoxComponent implements OnInit {

  addBoxInterfaceToBoxForm: UntypedFormGroup;
  @Output() saved = new EventEmitter<void>();
  @Output() canceled = new EventEmitter<void>();
  loadingBoxInterfaces = false;
  saving = false;
  flag = false;
  generalError?: ApiResponse;
  entities = Constants.entities;

  boxInterfaces: BoxInterface[] = [];
  filteredBoxInterfaces: BoxInterface[] = [];

  constructor(
    private boxService: BoxesService,
    private snackService: SnackService,
    private simsService: SimsService,
    private boxInterfacesService: BoxInterfacesService,
  ) {

    this.addBoxInterfaceToBoxForm = new UntypedFormGroup(
      {

        boxInterfaces: new UntypedFormControl(
          null,
          [Validators.required]
        ),
      }
    );
  }

  _box = new Box();
  selectedBoxInterfaces?: BoxInterface[];

  @Input() set box(value: Box) {
    this._box = merge(new Box(), value);
  }

  ngOnInit(): void {
    this.loadingBoxInterfaces = true;

    this.boxInterfacesService.getAllBoxInterfaces().subscribe(availableBoxInterfaces => {
      if (this._box.boxInterfaces) {
        this._box.boxInterfaces.forEach(alreadyAssignedBoxInterface => {
          const alreadyAssigned = availableBoxInterfaces.find(availableBoxInterface => availableBoxInterface.id === alreadyAssignedBoxInterface.id);
          if (alreadyAssigned) {
            availableBoxInterfaces.splice(availableBoxInterfaces.indexOf(alreadyAssigned), 1);
          }
        });
      }
      this.filteredBoxInterfaces = availableBoxInterfaces;
      this.loadingBoxInterfaces = false;
    });

  }


  addBoxInterfaces(): void {
    this.saving = true;
    const options : TransformValidationOptions  = {validator: { whitelist: true } };
    if (this.selectedBoxInterfaces) {
      const boxInterfaces = { boxInterfaces: this.selectedBoxInterfaces.map(boxInterface => boxInterface.id)};
      const boxInterfacesDTO = transformAndValidateSync(AssignBoxInterfaceDTO, boxInterfaces, options);

      this.boxInterfacesService.associateBoxInterfaces(this._box?.id, boxInterfacesDTO)
        .subscribe(
          () => {
            this.saving = false;
            this.snackService.success('Box interfaces associated!');
            this.saved.emit();
          },
          error => {
            this.saving = false;
            this.snackService.error(error.message);
            this.generalError = error;
          });
        }
  }
}
